module.exports = __webpack_public_path__ + "static/media/cap4-leg-desk.378b685e.png";